import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { get2DigitsDate } from "../helpers/DateHelper";

import classes from "./EventsReminder.module.css";

const EventsReminder = React.memo(() => {
  const { reminderEvents } = useSelector((state: RootState) => state.events);

  const [reminderEvent, setReminderEvent] = useState(0);

  const reminderEventItem = reminderEvents[reminderEvent];

  let outputReminderEventItemDate;
  if (reminderEventItem) {
    outputReminderEventItemDate = get2DigitsDate(reminderEventItem.date);
  }

  const wrapperClass = `${classes.wrapper} ${
    window.desktop ? classes.wrapperDesktop : ""
  }`;

  useEffect(() => {
    if (reminderEvents.length > 1) {
      let reminderTimeout: ReturnType<typeof setTimeout>;
      reminderTimeout = setTimeout(() => {
        setReminderEvent((prevState) => {
          return prevState + 1 < reminderEvents.length ? prevState + 1 : 0;
        });
      }, 6000);

      return () => {
        clearTimeout(reminderTimeout);
      };
    }
  }, [reminderEvent, reminderEvents, setReminderEvent]);

  return (
    <div className={wrapperClass}>
      <div className={classes.bg}>
        <ul className={classes.list}>
          <li className={classes.item}>
            <div className={classes.cell}>
              <span className={classes.date}>
                {outputReminderEventItemDate}
              </span>
              &nbsp;&mdash; {reminderEventItem && reminderEventItem.title}
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
});

export default EventsReminder;
